// Central brand config — change these values to rebrand the whole portal.
export const BRAND = {
  companyName: "SparkField Ops",
  shortName: "SF",
  productName: "Field Ops & Billing",
  tagline: "Ship faster.",
  headline: "Report smart.",
  description: "One portal for site visits, GPS-verified follow-ups, quotations and instant HQ email. Built for field teams, shop floors and admins.",
  pill: "India-First · GST · Field-Ready",
  copyright: "© 2026 SparkField Ops · All rights reserved.",
};
